import {
    BadRule,
    GoodRule,
    RulesGroupBad,
    RulesGroupGood,
    RulesGroupTitleBad,
    RulesGroupTitleGood,
    RulesList,
} from "./styled";

export const RulesTable = () => {
    return (
        <>
            <div className="text-xl sm:text-2xl font-bold text-center w-full pb-4">
                Если на нескольких примерах, то:
            </div>
            <div className="flex flex-col sm:flex-row flex-wrap box-border gap-2 sm:gap-8 pb-4 sm:justify-center">
                <RulesGroupGood>
                    <RulesGroupTitleGood>
                        Можно 👍
                    </RulesGroupTitleGood>
                    <RulesList className="list-disc">
                        <GoodRule>
                            Кричать что есть силы
                        </GoodRule>
                        <GoodRule>
                            Вскакивать с мест во время опасных моментов
                        </GoodRule>
                        <GoodRule>
                            Праздновать гол от души
                        </GoodRule>
                        <GoodRule>
                            Применять разрешенные средства поддержки
                        </GoodRule>
                        <GoodRule>
                            Принимать пищу на трибунах во время игры
                        </GoodRule>
                        <GoodRule>
                            Свободно перемещаться в рамках своего сектора
                        </GoodRule>
                        <GoodRule>
                            Общаться, делиться хорошим настроением
                        </GoodRule>
                    </RulesList>
                </RulesGroupGood>
                <RulesGroupBad>
                    <RulesGroupTitleBad>
                        Нельзя 👎
                    </RulesGroupTitleBad>
                    <RulesList className="list-disc">
                        <BadRule>
                            Оскорблять и призывать к насилию
                        </BadRule>
                        <BadRule>
                            Мешать просмотру другим зрителям
                        </BadRule>
                        <BadRule>
                            Портить имущество стадиона
                        </BadRule>
                        <BadRule>
                            Использовать запрещенную символику, зажигать фаеры и другую пиротехнику, бросать предметы на поле
                        </BadRule>
                        <BadRule>
                            Проносить на стадион еду и напитки, а также другие запрещенные к проносу на стадион предметы
                        </BadRule>
                        <BadRule>
                            Занимать чужие места на трибунах, переходить на другой сектор и уж тем более выбегать на поле
                        </BadRule>
                        <BadRule>
                            Вести пропаганду и незаконную торговлю
                        </BadRule>
                    </RulesList>
                </RulesGroupBad>
            </div>
        </>
    );
}
